export const dialogStyleAddModal = {
  '& .MuiDialog-paper': {
    width: '100%',
    maxWidth: '800px',
    borderRadius: '24px',
  },
};

export const dialogChildrenModal = {
  '& .MuiDialog-paper': {
    width: '100%',
    maxWidth: '600px',
  },
};
